// TODO: create a CMS-agnostic, non-contentstack driven form

import React from "react";

export const AgnosticEmailForm: React.FC = () => {
  return <p>Hi, I'm a non-contentstack-driven form</p>;
};

export default AgnosticEmailForm;
